export default class GridItem {
    constructor(data) {
        this.data = data;
    }

    update(property, value) {
        let item = this.data[property.substring(0, property.lastIndexOf('__'))];

        if (item.original === value) {
            item.updated = '';
            item.is_updated = false;
        } else {
            item.updated = value;
            item.is_updated = true;
        }
    }
}
